module.exports = __webpack_public_path__ + "img/hp-one-2.41551956.jpg";